import {createSvgIcon} from '../create-svg-icon';

export const ReviewsIcon = createSvgIcon(
  [<path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z" key="0" />,<path d="m12 15 1.57-3.43L17 10l-3.43-1.57L12 5l-1.57 3.43L7 10l3.43 1.57z" key="1" />,]
, 'ReviewsOutlined');
